/**
 * API Client
 * Re-export of the api service for convenience
 */

import apiService from '../services/api.service';

// Export as apiClient for consistency
export const apiClient = apiService;

export default apiClient;
